import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    projectTypeId: number
}

interface ProjectTypeWorkflowDefinition {
    projectTypeId: number
    workflowDefinitionId: number
}

const AddProjectTypeWorkflowDefinitionPopup: React.FC<Props> = ({ show, onHide, projectTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const workflows = useSelectListOptions('api/v1/selectlist/WorkflowDefinitions', '-- Select workflow');

    const [formData, setFormData] = useState<ProjectTypeWorkflowDefinition|undefined>({
        projectTypeId: projectTypeId,
        workflowDefinitionId: 0,
    });

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/WorkflowDefinitionProjectTypes/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && onHide)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'workflowDefinitionId', label: 'Workflow', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add workflow'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('workflowDefinitionId')} options={workflows} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProjectTypeWorkflowDefinitionPopup;